var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOnePersonWorking(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:none;stroke:#ffffff;stroke-width:2px;}.cls-1{stroke-miterlimit:10;}.cls-2{stroke-linejoin:round;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "one_person_working") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Laag_2",
    "data-name": "Laag 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12,11A4.06,4.06,0,0,1,8,6.71V5.29a4,4,0,1,1,8,0V6.71A4.06,4.06,0,0,1,12,11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M21,45,15,34H8a4,4,0,0,1-4-4V17a3,3,0,0,1,3-3h3l5,6h6s.45,4-3,4H12L8,19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M11,23v5h4.32c1.6,0,3.15.49,3.68,2l7,15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13,37H6a5,5,0,0,1-5-5V19"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 7,
    y1: 37,
    x2: 7,
    y2: 45
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "18 17 22 10 38 10 32 21 24 21"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 11,
    y1: 24,
    x2: 40,
    y2: 24
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 2,
    y1: 45,
    x2: 12,
    y2: 45
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 35,
    y1: 24,
    x2: 35,
    y2: 46
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnePersonWorking);
export default __webpack_public_path__ + "static/media/one-person-working.e10763e1bcf859183cc84ce5cb5e9929.svg";
export { ForwardRef as ReactComponent };